<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Client Employment</h4>
        <button type="button" #closebtn class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="employmentform" (ngSubmit)="saveEmployment()">
            <div class="form-body">
                <div class="row mb-3">
                    <div class="col-lg-6">
                        <label>Employer</label>
                        <div class="input-group">
                            <select class="form-control" formControlName="employer_id" >
                                <option *ngFor="let item of employers" value="{{item.id}}">{{item.employer_name}}</option>
                            </select>
                        </div>
                    </div>
                     <div class="col-lg-6">
                        <label>Employment Type</label>
                        <div class="input-group">
                            <select class="form-control" formControlName="employment_type" >
                                <option *ngFor="let item of employmentTypes" value="{{item.id}}">{{item.lookup_name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-lg-6 ">
                        <label>Start Date</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="employment_start_date" ngbDatepicker #startDate="ngbDatepicker" 
                            placeholder="dd-mm-yyyy"  (dateSelect)="updateStartDate($event)"/>
                            <button class="btn btn-primary bx bx-calendar" (click)="startDate.toggle()" type="button"></button>
                        </div>
                        <!-- <span *ngIf="employmentform.employment_start_date && employmentform.employment_start_date.invalid" class="errormessage">Please enter valid Start Date</span> -->
                        </div>
                    <div class="col-lg-6">
                        <label>End Date</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="employment_end_date" ngbDatepicker #endDate="ngbDatepicker" 
                            placeholder="dd-mm-yyyy" (dateSelect)="updateEndDate($event)"/>
                            <button class="btn btn-primary bx bx-calendar" (click)="endDate.toggle()" type="button"></button>
                        </div>
                        <!-- <span *ngIf="employment_end_date && employment_end_date.invalid" class="errormessage">Please enter valid End Date</span> -->
                    </div>
                </div>
                <div class="row">
                     <div class="input-group">
                        <button [disabled]="employmentform.invalid" type="submit" class="btn btn-primary">Save</button>
                    </div>
                    <span [ngClass]="errorclass" >{{errormessage}}</span>
                </div>
            </div>
        </form>
    </div>
</ng-template>